VP = window.VP || {};

(function( $ ) {
	VP.socialShare = {
		init: function () {
			this.initSocialShare();
		},

		initSocialShare: function() {
			$(".nc_tweetContainer a").on("click", function (e) {
				if (e.preventDefault) {
					e.preventDefault();
				} else {
					e.returnValue = false;
				}

				if( $( this ).attr( 'data-link' ) ) {

					var href = $( this ).attr( 'data-link' );
					var height, width, instance, network;

					href = href.replace( '’', '\'' );
					height = 270;
					width = 500;

					instance = window.open( href, '_blank', 'height=' + height + ',width=' + width );

					if (typeof ga === "function" && true === swpClickTracking) {
						if($(this).hasClass('nc_tweet')) {
							network = $(this).parents(".nc_tweetContainer").attr("data-network");
						} else if ($(this).hasClass('swp_CTT') ) {
							network = 'ctt';
						}
					}

					return false;
				}
			});
		},
	};
})(jQuery);
